import { AppBox } from "../../../../commons/components";
import { User } from "../../../../commons/models/user";
import { toTitleCase } from "../../../../commons/utilities/string-utils";

interface UserDeactiveProps {
  user: User;
}
export default function UserDeactive({ user }: UserDeactiveProps) {
  return (
    <AppBox displayBlock>
      Once you deactivate user <strong>“{toTitleCase(user.fullName)}”</strong>,
      the user will no longer be able to log into the application.
    </AppBox>
  );
}
